import Icon from 'vue-awesome/components/Icon'

Icon.register({
  create_sharp: {
    paths: [
      {
        d: 'M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM21.41 6.34l-3.75-3.75-2.53 2.54 3.75 3.75 2.53-2.54z'
      }
    ],
    width: '24',
    height: '24'
  }
})
